import { TQMSVehicleInterface, VehicleCategory, VehicleInfo } from "./Fleet";
import { DriversForVehicleApiResponse } from "../../fleet/presentation/store/types";

export const IFleetRepositoryToken = Symbol();

export interface IFleetRepository {
  createVehicleCategory: (values: any) => Promise<any>;
  getAllVechiles: (page: number, input: string, filter: string, report: string, limit?: number) => Promise<any>;
  getAllVehiclesOfDriver: (driverId: number) => Promise<any>;
  getAVehicle: (id: number) => Promise<any>;
  deleteVehicle: (id: number) => Promise<any>;
  getAllVehicleCategory: (page: number, input: string, filter: string) => Promise<any>;
  deleteVehicleCategory: (id: number) => Promise<any>;
  getVehicleCategory: (id: number) => Promise<any>;
  updateVehicleCategory: (id: number, values: VehicleCategory) => Promise<any>;
  getUnits: () => Promise<any>;
  createUnit: (values: any) => Promise<any>;
  createVehicleTypes: (values: any) => Promise<any>;
  updateVehicleTypes: (is: number, values: any) => Promise<any>;
  createTrip: (values: any) => Promise<any>;
  getAllTrip: (page: number, input: string, filter: string, ongoing: string, createdOnly?: boolean) => Promise<any>;
  getAllCompletedTrips: (page: number) => Promise<any>;
  getATrip: (id: number, showMap: boolean) => Promise<any>;
  deleteTrip: (id: number) => Promise<any>;
  getAllVehicleTypes: (page: number, input: string, filter: string) => Promise<any>;
  updateTripStatus: (id: number, values: any) => Promise<any>;
  updateTrip: (id: number, values: any) => Promise<any>;
  getAllChangeRequests: (page: number, input: string, filter: string) => Promise<any>;
  changeVehicleRequestStatus: (id: number, values: any) => Promise<any>;
  checkVehicleExistance: (values: any) => Promise<any>;
  changeVehicleOwn: (id: number, values: any) => Promise<any>;
  changeVehicleOthers: (id: number, values: any) => Promise<any>;
  getVehicleType: (id: number) => Promise<any>;
  deleteVehicleType: (id: number) => Promise<any>;
  getAllVehicleOwnerList: () => Promise<any>;
  getTripCoordinatesById: (id: number) => Promise<any>;
  getAllVehiclePlateColors: () => Promise<any>;
  getVehiclePolicyTypes: () => Promise<any>;
  createVehicle: (values: any) => Promise<any>;
  updateVehicle: (id: number, values: VehicleCategory) => Promise<any>;
  getAvailableVehicleForBidding: (id: number) => Promise<any>;
  getNewBids: (page: number, input?: string, filter?: string) => Promise<any>;
  newBidRequest: (values: any) => Promise<any>;
  getRejectedBids: (page: number, input: string, filter?: string) => Promise<any>;
  getAcceptedBids: (page: number, input?: string, filter?: string) => Promise<any>;
  getCancelledBids: (page: number, input: string, filter?: string) => Promise<any>;
  acknowledgeDigitalContract: (values: any) => Promise<any>;
  cancelBidRequest: (values: any) => Promise<any>;
  acknowledgeContract: (values: any) => Promise<any>;
  userPayment: (values: any) => Promise<any>;
  transactionPayment: (values: any) => Promise<any>;
  transferOwnership: (values: any) => Promise<any>;
  cancelOrder: (values: any) => Promise<any>;
  getAllVehicles: () => Promise<any>;
  getVehicleCheckList: (page: number, input: string, filter: string) => Promise<any>;
  getVehicleLogHistory: (page: number, input: string, filter: string) => Promise<any>;
  getDeclinedVehicleReport: (page: number, input: string, filter: string) => Promise<any>;
  getRejectedVehicleReport: (page: number, input: string) => Promise<any>;
  getEditRequestVehicleReport: (page: number, input: string, filter: string) => Promise<any>;
  getAwaitingApprovalVehicleReport: (page: number, input: string, filter: string) => Promise<any>;
  getTQMSPendingVehicles: (page: number, input: string, filter: string) => Promise<any>;
  getLoadBoardPendingVehicles: (page: number, input: string, filter: string) => Promise<any>;
  getAwaitingApprovalDriverReport: (type: string, page: number, input: string) => Promise<any>;
  getStatusDriverReport: (values: any) => Promise<any>;
  getStatusVehicleReport: (values: any) => Promise<any>;
  getInsuranceCompany: () => Promise<any>;
  checkUniqueVehicleNumber: (plateNumber: string) => Promise<any>;
  getUnassignedDriver: () => Promise<any>;
  getAllDriversOfVehicle: (vehicleId: number) => Promise<DriversForVehicleApiResponse>;
  assignDriver: (values: any) => Promise<VehicleInfo>;
  updateVehicleStatus: (id: number, values: any) => Promise<any>;
  getOrderBidDetails: (id: number) => Promise<any>;
  getOnboardingData: (status: string, type: string, page: number, input: string) => Promise<any>;
  getVehicleOnBoardingLists: (page: number, input: string, filter: string, status?: string) => Promise<any>;
  setVehicleEditOnBoarding: (id: number, value: any) => Promise<any>;
  getVehicleDetailsById: (value: { vehicleId: number }) => Promise<any>;
  getSthaniya: () => Promise<any>;
  getProformaInvoice: (id: number) => Promise<any>;
  getTQMSVehicleDetails: (id: number) => Promise<TQMSVehicleInterface>;
  getPendingVehicleDetails: (id: number) => Promise<any>;
  getPendingApprovalVehicles: (page: number, input: string, filter: string, status: string) => Promise<any>;
  acceptrejectvehicle: (values: any) => Promise<any>;
  getTripActualPath: (id: number) => Promise<any>;
  getAVehicleChangeRequestById: (id: number) => Promise<any>;
  getVirtualCheckpoints: (page: number, input: string, filter: string) => Promise<any>;
  createVirtualCheckpoint: (values: any) => Promise<any>;
  updateVirtualCheckpoint: (id: number, values: any) => Promise<any>;
  deleteVirtualCheckpoint: (id: number) => Promise<any>;
  getPaymentDetails: (txnId: string) => Promise<any>;
  getNepalPayDetails: (validationTraceId: string) => Promise<any>;
  getVehiclePlanTrend: (page: number, input: string, filter: string, vehicleId: number) => Promise<any>;
  getVehicleScheduledPlan: (page: number, input: string, filter: string, vehicleId: number) => Promise<any>;
  getCancelledPlan: (vehicleId: number) => Promise<any>;
  updateContractVehicle: (id: any, values: any) => Promise<any>;
  getVehicleContractHistory: (vehicleId: number) => Promise<any>;
  cancelSubscription: (vehicleId: number, data: { documentId?: number; additionalDetails?: string }) => Promise<any>;
  getApplicableCancellationPolicy: (vehicleId: number) => Promise<any>;
  getSubscriptionExpiryReminders: () => Promise<any>;
  updateSubscriptionExpiryReminder: (reminderId: number, data: { remindBeforeDays: number }) => Promise<any>;
  updatePlan: (value: any) => Promise<any>;
  updatePaymentStatus: (value: any) => Promise<any>;
  verifyPromoCode: (valus: any) => Promise<any>;
  getApplicablePromoCode: (page: number, limit?: number, search?: string, filter?: string) => Promise<any>;
  getAppliedPromoCode: (page: number, limit?: number, search?: string, filter?: string) => Promise<any>;
  getLiveShipmentTrack: () => Promise<any>;
  getPaymentLogs: (values: any) => Promise<any>;
  getCommissionReport: (values: any) => Promise<any>;
  getUnassignedDriverV2: (vehicleId: number) => Promise<any>;
  getUnassignedVehicleV2: (driverId: number) => Promise<any>;
  getSearchVehicle: (query: string) => Promise<any>;
  vehicleAction: (vehicleId: number, values: any) => Promise<any>;
  shiftVehicleOwnerThunk: (vehicleId: number, values: any) => Promise<any>;
  getAllVehicleStatus: () => Promise<any>;
  updateEligibleVehicleStatus: (vehicleStatusId: number) => Promise<any>;
  updatePlanFeatures: (planId: number, featureIds: number[]) => Promise<any>;
}
